import getBrowserFingerprint from 'get-browser-fingerprint'
import { md5 } from 'js-md5'

let fingerprint = ''
const FINGERPRINT_KEY = 'dfans_visitor_id'

const generateFingerprint = () => {
  // 使用稳定的设备特征
  const baseFingerprint = getBrowserFingerprint({ hardwareOnly: true })
  if (!baseFingerprint) {
    console.warn('Failed to get browser fingerprint')
  }

  const enhancedData = [
    baseFingerprint || '',
    window.screen?.width || '',
    window.screen?.height || '',
    window.screen?.colorDepth || '',
    navigator?.language || '',
    navigator?.platform || '',
  ]
    .filter(Boolean)
    .join('_') // 过滤掉空值

  return `fp_${md5(enhancedData || 'fallback')}`
}

const getStoredFingerprint = () => {
  try {
    // 先尝试从 localStorage 获取
    let storedFp = localStorage.getItem(FINGERPRINT_KEY)
    if (!storedFp) {
      // 如果没有存储过，生成新的并存储
      storedFp = generateFingerprint()
      localStorage.setItem(FINGERPRINT_KEY, storedFp)
    }
    return storedFp
  } catch (error) {
    return generateFingerprint()
  }
}

export const useReport = () => {
  /**
   * @description 上报埋点
   * event
   *  页面访问  page_view
   *  按钮点击  button_click
   *  异常信息  error_event
   *  提交订单  purchase_submit
   */
  const addTrack = async (params: any) => {
    try {
      if (!fingerprint) {
        fingerprint = getStoredFingerprint()
      }
      await reportService.addTrack({
        ...params,
        extra: {
          ...params.extra,
          fingerprint,
        },
      })
    } catch (error) {
      console.error('Failed to report page visit:', error)
    }
  }

  const checkImageStatus = async (url: string): Promise<number | null> => {
    try {
      if (!url) return 200
      const response = await fetch(url, {
        method: 'HEAD',
        mode: 'cors', // ✅ 确保跨域请求被允许
        cache: 'no-cache', // 🔁 避免本地缓存干扰结果
      })
      return response.status
    } catch (error) {
      console.error('Image status check failed:', error)
      return null
    }
  }

  return {
    addTrack,
    checkImageStatus,
  }
}
